import "firebase/messaging";

import * as firebase from "firebase/app";
// import * as querystring from "querystring";
const queryString = require('query-string');

let messaging;

if (firebase.messaging.isSupported()) {

		const initializedFirebaseApp = firebase.initializeApp({
			messagingSenderId: "387283072587",
		});
		messaging = initializedFirebaseApp.messaging();
		messaging.usePublicVapidKey(
			"BP-A58CoGebuqwzFZOmCdf3TLMOUTEf246PJTdWPcTaie-Fce6DQOpuw8OkkXrGj64oF4pbOgPkFqFzT5AYV1QI"
		);
}

export default messaging;
